import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import StickyContact from './StickyContact';
import SocialIcons from './SocialIcons';
import EnquiryModal from './EnquiryModal';
import WebsitePopup from './WebsitePopup';
import { useState } from 'react';

export default function Layout() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState({});

  const openModal = (data = {}) => {
    setModalData(data);
    setIsModalOpen(true);
  };

  return (
    <div className="min-h-screen">
      <Header onOpenModal={openModal} />
      <SocialIcons />
      <StickyContact onOpenModal={openModal} />
      <main>
        <Outlet context={{ openModal }} />
      </main>
      <Footer />
      <WebsitePopup />
      <EnquiryModal 
        open={isModalOpen} 
        onOpenChange={setIsModalOpen}
        initialData={modalData}
      />
    </div>
  );
}